var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_473:2296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1514 11.0002H16.8486C16.6091 10.9967 16.3714 11.0424 16.1489 11.1347C15.9263 11.227 15.7235 11.364 15.5518 11.538C15.3801 11.7119 15.2431 11.9194 15.1484 12.1486C15.0537 12.3778 15.0033 12.6241 15 12.8736V35.3281C15.0033 35.5775 15.0537 35.8239 15.1484 36.0531C15.2431 36.2822 15.3801 36.4897 15.5518 36.6637C15.7235 36.8376 15.9263 36.9747 16.1489 37.067C16.3714 37.1592 16.6091 37.2049 16.8486 37.2015H38.1514C38.3909 37.2049 38.6286 37.1592 38.8511 37.067C39.0737 36.9747 39.2765 36.8376 39.4482 36.6637C39.6199 36.4897 39.7569 36.2822 39.8516 36.0531C39.9463 35.8239 39.9967 35.5775 40 35.3281V12.8736C39.9967 12.6241 39.9463 12.3778 39.8516 12.1486C39.7569 11.9194 39.6199 11.7119 39.4482 11.538C39.2765 11.364 39.0737 11.227 38.8511 11.1347C38.6286 11.0424 38.3909 10.9967 38.1514 11.0002ZM22.583 32.9307H18.8104V21.1401H22.583V32.9307ZM20.6967 19.4894C20.1764 19.4894 19.6774 19.2741 19.3095 18.8908C18.9416 18.5075 18.7349 17.9877 18.7349 17.4457C18.7349 16.9037 18.9416 16.3839 19.3095 16.0006C19.6774 15.6173 20.1764 15.402 20.6967 15.402C20.973 15.3694 21.2527 15.3979 21.5177 15.4857C21.7827 15.5735 22.0268 15.7186 22.2342 15.9116C22.4416 16.1045 22.6076 16.3409 22.7212 16.6053C22.8348 16.8696 22.8935 17.156 22.8935 17.4457C22.8935 17.7354 22.8348 18.0218 22.7212 18.2861C22.6076 18.5505 22.4416 18.7869 22.2342 18.9798C22.0268 19.1728 21.7827 19.3179 21.5177 19.4057C21.2527 19.4935 20.973 19.522 20.6967 19.4894ZM36.1896 32.9307H32.417V26.6031C32.417 25.0179 31.8763 23.9829 30.5055 23.9829C30.0813 23.9862 29.6682 24.1248 29.322 24.3801C28.9757 24.6354 28.7129 24.9952 28.5689 25.4109C28.4705 25.7188 28.4279 26.0431 28.4432 26.3672V32.9176H24.6705C24.6705 32.9176 24.6705 22.2012 24.6705 21.127H28.4432V22.7908C28.7859 22.1712 29.2843 21.6609 29.8849 21.3146C30.4854 20.9683 31.1652 20.7993 31.8511 20.8257C34.3662 20.8257 36.1896 22.5157 36.1896 26.1445V32.9307Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_473:2296",
    x: 0,
    y: 0,
    width: 55,
    height: 56.2012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_473:2296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_473:2296",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.dc6df1a2.svg";
export { ForwardRef as ReactComponent };